
// filter buttons
document.querySelectorAll('.filter-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    this.classList.add('active');

    // Prefer the explicit value so a category can be relabelled without retagging every project.
    // Falling back to the button's text keeps older markup working.
    const filter = (this.dataset.filter || this.textContent).trim().toLowerCase();
    document.querySelectorAll('.project').forEach(card => {
      if (filter === 'all') {
        card.style.display = '';
      } else {
        const cats = (card.dataset.category || '').toLowerCase();
        card.style.display = cats.includes(filter) ? '' : 'none';
      }
    });
  });
});

// scroll reveal on portfolio
const obs = new IntersectionObserver((entries) => {
  entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('vis'); obs.unobserve(e.target); }});
}, { threshold: 0.08 });
document.querySelectorAll('.reveal').forEach(el => obs.observe(el));

// ---- view switching with a calm fade ----
function fadeIn(el){
  if(!el) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  el.style.opacity = '0';
  requestAnimationFrame(function(){ el.style.transition = 'opacity 0.5s ease'; el.style.opacity = '1'; });
}
function hideAllViews(){
  ['view-portfolio','view-start'].forEach(function(id){
    var el = document.getElementById(id); if(el) el.style.display = 'none';
  });
  document.documentElement.classList.remove('nav-hidden'); // always show the masthead on view change
  document.documentElement.classList.remove('on-portfolio'); // other views are light at the top → solid nav
  document.documentElement.classList.remove('at-hero-top');
}
function _disp(id, v){ var e = document.getElementById(id); if(e) e.style.display = v; }  // guarded display helper

// nav rides transparent over the dark hero only while the portfolio view is at the top
function updateNavTheme(){
  var root = document.documentElement;
  var atTop = (window.pageYOffset || window.scrollY || 0) < 80;
  root.classList.toggle('at-hero-top', root.classList.contains('on-portfolio') && atTop);
}

// Contact lives at /pages/contact now. Kept as a redirect so any old #contact link,
// bookmark or cached button still lands in the right place.
function openContact() {
  window.location.href = '/pages/contact';
}

// Case studies are real pages (/pages/<project>); the old in-page view is gone.

// open the Start Your Project view (faded, not scrolled)
function openStart() {
  hideAllViews();
  var v = document.getElementById('view-start'); if(!v) return;
  v.style.display = 'block';
  // reset the intake to a fresh form in case a prior submission left the success screen showing
  var head = v.querySelector('.begin-head'); if (head) head.style.display = '';
  var intakeForm = v.querySelector('.intake'); if (intakeForm) intakeForm.style.display = '';
  var done = v.querySelector('.intake-done'); if (done) done.hidden = true;
  window.scrollTo({ top: 0, behavior: 'instant' });
  fadeIn(v);
}

// open the Services view (faded, its own page)
// back to portfolio
function showPortfolio() {
  hideAllViews();
  var pv = document.getElementById('view-portfolio'); if(!pv) return;
  pv.style.display = 'block';
  document.documentElement.classList.add('on-portfolio');
  window.scrollTo({ top: 0, behavior: 'instant' });
  updateNavTheme();
  fadeIn(pv);
}

// calm, eased in-page scroll (respects reduced motion)
window.calmScroll = function(sel){
  var el = document.querySelector(sel); if(!el) return;
  var nav = document.getElementById('main-nav');
  var offset = (nav ? nav.offsetHeight : 0) + 8;
  var startY = window.pageYOffset || document.documentElement.scrollTop;
  var targetY = el.getBoundingClientRect().top + startY - offset;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){ window.scrollTo(0, targetY); return; }
  var dist = targetY - startY, dur = 950, t0 = null;
  function ease(t){ return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3) / 2; }
  function step(ts){ if(!t0) t0 = ts; var p = Math.min((ts - t0) / dur, 1); window.scrollTo(0, startY + dist * ease(p)); if(p < 1) requestAnimationFrame(step); }
  requestAnimationFrame(step);
};

// nav links: return to the portfolio view if needed, then calm-scroll to the section
// nav links: return to the homepage view if needed, then gently ease to the section
window.navTo = function(sel){
  var pv = document.getElementById('view-portfolio');
  if(pv && getComputedStyle(pv).display === 'none'){ showPortfolio(); setTimeout(function(){ calmScroll(sel); }, 80); }
  else { calmScroll(sel); }
};

// auto-hide nav: hide on scroll-down, reveal on scroll-up
(function () {
  var nav = document.getElementById('main-nav');
  if (!nav) return;
  var root = document.documentElement;
  var last = window.pageYOffset || 0;
  var threshold = 6;     // ignore tiny scrolls (anti-jitter)
  var revealAbove = 80;  // always show near the very top
  var ticking = false;
  function update() {
    if (root.classList.contains('nav-open')) { ticking = false; return; }  // keep masthead put while the menu is open
    var y = window.pageYOffset || 0;
    if (Math.abs(y - last) > threshold) {
      if (y > last && y > revealAbove) {
        root.classList.add('nav-hidden');     // scrolling down → tuck the masthead away
      } else {
        root.classList.remove('nav-hidden');  // scrolling up → bring it back
      }
      last = y;
    }
    updateNavTheme();
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
})();

// mobile menu: hamburger toggles a slide-out vertical drawer
(function () {
  var burger = document.getElementById('nav-burger');
  var links  = document.getElementById('nav-links');
  var root   = document.documentElement;
  if (!burger || !links) return;
  function setOpen(open) {
    root.classList.toggle('nav-open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  burger.addEventListener('click', function (e) {
    e.stopPropagation();
    setOpen(!root.classList.contains('nav-open'));
  });
  // tapping a link (or the CTA) navigates and closes the drawer
  links.addEventListener('click', function (e) {
    if (e.target.closest('.nav-link, .nav-cta')) setOpen(false);
  });
  // tap outside the drawer, or Esc, closes it
  document.addEventListener('click', function (e) {
    if (root.classList.contains('nav-open') && !e.target.closest('#nav-links') && !e.target.closest('#nav-burger')) setOpen(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
})();

// testimonials carousel — one review at a time; click chevrons (no autoplay)
(function () {
  var slides = [].slice.call(document.querySelectorAll('.tm-slide'));
  if (slides.length < 2) return;
  var cur = document.querySelector('.tm-c-cur');
  var tot = document.querySelector('.tm-c-tot');
  var fill = document.querySelector('.tm-c-fill');
  var total = slides.length;
  var i = 0;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  if (tot) tot.textContent = pad(total);
  function show(n) {
    i = (n + total) % total;
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    if (cur) cur.textContent = pad(i + 1);
    if (fill) fill.style.width = (((i + 1) / total) * 100) + '%';
  }
  var prev = document.querySelector('.tm-c-prev');
  var next = document.querySelector('.tm-c-next');
  if (prev) prev.addEventListener('click', function () { show(i - 1); });
  if (next) next.addEventListener('click', function () { show(i + 1); });

  var viewport = document.querySelector('.tm-c-viewport');
  if (viewport) {
    // keyboard: focusable region; arrows page reviews only while focused (never hijacks page scroll)
    viewport.setAttribute('tabindex', '0');
    viewport.setAttribute('role', 'group');
    viewport.setAttribute('aria-label', 'Client reviews; use left and right arrow keys');
    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); }
    });
    // touch: swipe left/right on mobile
    var x0 = null;
    viewport.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    }, { passive: true });
  }
  show(0);
})();

// intake funnel — multi-step qualification; final step opens Calendly (no autoplay)
(function () {
  var form = document.querySelector('.intake');
  if (!form) return;
  form.classList.add('js');
  form.noValidate = true; // JS drives validation (consistent messages + jump-to-step); attrs stay for no-JS/a11y
  var steps = [].slice.call(form.querySelectorAll('.intake-step'));
  var total = steps.length;
  var cur = form.querySelector('.intake-cur');
  var tot = form.querySelector('.intake-tot');
  var fill = form.querySelector('.intake-fill');
  var backBtn = form.querySelector('.intake-back');
  var nextBtn = form.querySelector('.intake-next');
  var bookBtn = form.querySelector('.intake-book');
  var errEl = form.querySelector('.intake-err');
  var idx = 0;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  if (tot) tot.textContent = pad(total);
  function render() {
    steps.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
    if (cur) cur.textContent = pad(idx + 1);
    if (fill) fill.style.width = (((idx + 1) / total) * 100) + '%';
    if (backBtn) backBtn.style.visibility = idx === 0 ? 'hidden' : 'visible';
    if (nextBtn) nextBtn.style.display = (idx === total - 1) ? 'none' : 'inline-block';
    if (bookBtn) bookBtn.style.display = (idx === total - 1) ? 'inline-block' : 'none';
  }
  // Three steps. Only what's needed to judge fit blocks a submission: what they need,
  // enough scope to understand it, a budget range, and how to reach them. Stage,
  // functionality, timeline, inspiration, notes and referral source are all optional.
  function validateStep(i) {
    var m = [];
    if (i === 0 && !pick('type')) m.push('what you need');
    if (i === 1) {
      if (!val('business')) m.push('your business name');
      if (!val('industry')) m.push('your industry');
      if (!val('goals')) m.push('what you\u2019re hoping to achieve');
    }
    if (i === 2) {
      if (!pick('budget')) m.push('an investment range');
      if (!val('name')) m.push('your name');
      if (!isEmail(val('email'))) m.push('a valid email');
    }
    return m;
  }
  function firstIncompleteStep() {
    for (var s = 0; s < total; s++) { if (validateStep(s).length) return s; }
    return -1;
  }
  if (nextBtn) nextBtn.addEventListener('click', function () {
    var m = validateStep(idx);
    if (m.length) { markErrors(idx); if (errEl) errEl.textContent = 'Please add ' + m.join(', ') + ' to continue.'; return; }
    if (errEl) errEl.textContent = '';
    if (idx < total - 1) { idx++; render(); }
  });
  if (backBtn) backBtn.addEventListener('click', function () { if (idx > 0) { idx--; render(); } });
  [].slice.call(form.querySelectorAll('.intake-opt')).forEach(function (opt) {
    opt.setAttribute('aria-pressed', 'false');
    opt.addEventListener('click', function () {
      var g = opt.getAttribute('data-group');
      var box = opt.closest('.intake-opts');
      if (box && box.hasAttribute('data-multi')) {
        var on = opt.classList.toggle('is-sel');
        opt.setAttribute('aria-pressed', on ? 'true' : 'false');
      } else {
        [].slice.call(form.querySelectorAll('.intake-opt[data-group="' + g + '"]')).forEach(function (o) { o.classList.remove('is-sel'); o.setAttribute('aria-pressed', 'false'); });
        opt.classList.add('is-sel');
        opt.setAttribute('aria-pressed', 'true');
      }
      if (box) box.classList.remove('is-error');
      if (errEl) errEl.textContent = '';
      saveState();
    });
  });
  function pick(g){ var el = form.querySelector('.intake-opt[data-group="' + g + '"].is-sel'); return el ? (el.getAttribute('data-label') || el.textContent.trim()) : ''; }
  function picks(g){ return [].slice.call(form.querySelectorAll('.intake-opt[data-group="' + g + '"].is-sel')).map(function (o) { return o.getAttribute('data-label') || o.textContent.trim(); }); }
  var NAME = { business:'contact[Business name]', industry:'contact[Industry]', website:'contact[Website]', goals:'contact[Goals]', inspiration:'contact[Inspiration]', notes:'contact[Notes]', name:'contact[name]', email:'contact[email]' };
  function val(n){ var el = form.querySelector('[name="' + (NAME[n] || n) + '"]'); return el ? el.value.trim() : ''; }
  // ---- Failsafe: auto-save every answer to the browser so a glitch can never force a redo ----
  var SAVE_KEY = 'bb_intake_v1';
  // --- captures which package a visitor clicked on the Packages page, so it shows in the submission ---
  var PKG_NAMES = { audit:'Strategic Audit', brand:'Brand Guidelines', launch:'Launch Site', signature:'Signature Site', commerce:'Commerce Build', studio:'Studio Engagement' };
  var fInterest = document.getElementById('f-interest');
  var ctxEl = document.getElementById('begin-context');
  var ctxVal = document.getElementById('begin-context-val');
  function setInterest(fullValue, chipLabel){
    if (fInterest) fInterest.value = fullValue || '';
    if (chipLabel && ctxEl && ctxVal) { ctxVal.textContent = chipLabel; ctxEl.hidden = false; }
    else if (ctxEl) { ctxEl.hidden = true; }
    saveState();
  }
  function selectType(label){
    var found = false;
    [].slice.call(form.querySelectorAll('.intake-opt[data-group="type"]')).forEach(function (o) {
      var match = (o.getAttribute('data-label') === label);
      o.classList.toggle('is-sel', match); o.setAttribute('aria-pressed', match ? 'true' : 'false');
      if (match) found = true;
    });
    if (found) saveState();
    return found;
  }
  function applyInterestFromUrl(){
    try {
      var params = new URLSearchParams(location.search);
      var interest = (params.get('interest') || '').toLowerCase();
      var from = (params.get('from') || '').toLowerCase();
      if (PKG_NAMES[interest]) {
        setInterest(PKG_NAMES[interest] + ' \u2014 clicked on the Packages page', PKG_NAMES[interest]);
        selectType(PKG_NAMES[interest]);
      } else {
        if (from === 'packages') { setInterest('Came from the Packages page'); } // captured for you, no chip
        if (ctxEl) ctxEl.hidden = true;   // no specific package clicked -> hide the chip entirely
      }
    } catch (e) {}
  }
  function saveState(){
    try {
      var data = { ts: Date.now(), fields: {}, opts: {} };
      [].slice.call(form.querySelectorAll('.intake-input')).forEach(function (el) { if (el.name) data.fields[el.name] = el.value; });
      ['type','stage','time','budget','heard'].forEach(function (g) { data.opts[g] = pick(g); });
      ['functionality'].forEach(function (g) { data.opts[g] = picks(g); });
      window.localStorage.setItem(SAVE_KEY, JSON.stringify(data));
    } catch (e) {}
  }
  function restoreState(){
    try {
      var raw = window.localStorage.getItem(SAVE_KEY); if (!raw) return;
      var data = JSON.parse(raw);
      if (!data || (Date.now() - (data.ts || 0)) > 7200000) return; // ignore drafts older than 2 hours
      Object.keys(data.fields || {}).forEach(function (name) { var el = form.querySelector('[name="' + name + '"]'); if (el) el.value = data.fields[name]; });
      Object.keys(data.opts || {}).forEach(function (g) {
        var v = data.opts[g]; var vals = Array.isArray(v) ? v : (v ? [v] : []);
        [].slice.call(form.querySelectorAll('.intake-opt[data-group="' + g + '"]')).forEach(function (o) {
          var label = o.getAttribute('data-label') || o.textContent.trim();
          if (vals.indexOf(label) !== -1) { o.classList.add('is-sel'); o.setAttribute('aria-pressed', 'true'); }
        });
      });

    } catch (e) {}
  }
  function clearState(){ try { window.localStorage.removeItem(SAVE_KEY); } catch (e) {} }
  function fieldEl(name){ return form.querySelector('[name="' + name + '"]'); }
  function groupBox(g){ var el = form.querySelector('.intake-opt[data-group="' + g + '"]'); return el ? el.closest('.intake-opts') : null; }
  function mark(el, bad){ if (el) el.classList.toggle('is-error', !!bad); }
  function markErrors(i){
    if (i === 0) mark(groupBox('type'), !pick('type'));
    if (i === 1){
      mark(fieldEl('contact[Business name]'), !val('business'));
      mark(fieldEl('contact[Industry]'), !val('industry'));
      mark(fieldEl('contact[Goals]'), !val('goals'));
    }
    if (i === 2){
      mark(groupBox('budget'), !pick('budget'));
      mark(fieldEl('contact[name]'), !val('name'));
      mark(fieldEl('contact[email]'), !isEmail(val('email')));
    }
  }
  function setHidden(id, v){ var el = form.querySelector('#' + id); if (el) el.value = v; }
  function isEmail(s){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s); }
  // Validate all steps; if a gap remains, jump there and flag it. Returns false when incomplete.
  function composeAndValidate() {
    var bad = firstIncompleteStep();
    if (bad !== -1) {
      idx = bad; render(); markErrors(bad);
      if (errEl) errEl.textContent = 'Please add ' + validateStep(bad).join(', ') + ' to continue.';
      return false;
    }
    if (errEl) errEl.textContent = '';
    var interestVal = fInterest ? fInterest.value : '';
    var summary = [
      (interestVal ? 'Interested in: ' + interestVal : ''),
      'Project: ' + pick('type'),
      'Business: ' + val('business'),
      'Industry: ' + val('industry'),
      'Website: ' + (val('website') || '\u2014'),
      'Stage: ' + (pick('stage') || '\u2014'),
      'Goals / not working: ' + val('goals'),
      'Needs: ' + (picks('functionality').join(', ') || '\u2014'),

      'Timeline: ' + (pick('time') || '\u2014'),
      'Investment: ' + pick('budget'),
      'Inspiration: ' + (val('inspiration') || '\u2014'),
      'Notes: ' + (val('notes') || '\u2014'),
      'Name: ' + val('name'),
      'Email: ' + val('email'),
      'Heard about us: ' + (pick('heard') || '\u2014')
    ].filter(Boolean).join('\n');
    setHidden('f-type', pick('type'));
    setHidden('f-stage', pick('stage'));
    setHidden('f-needs', picks('functionality').join(', '));
    setHidden('f-time', pick('time'));
    setHidden('f-budget', pick('budget'));
    setHidden('f-heard', pick('heard'));
    setHidden('f-body', summary);
    return true;
  }
  function showConfirm(){
    form.style.display = 'none';
    var head = document.querySelector('.begin-head'); if (head) head.style.display = 'none'; // hide the form intro on the success screen
    var done = document.querySelector('.intake-done');
    if (done) { done.hidden = false; done.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }
  // Submit natively INTO A HIDDEN IFRAME. Shopify's built-in spam protection (hCaptcha) runs exactly as it
  // does for a normal form, so the submission is accepted; but because the response lands in the iframe, the
  // page never reloads and this single-page site never resets. (A raw fetch fails: hCaptcha isn't satisfied.)
  var submitted = false;
  var sink = document.getElementById('intake-sink');
  form.addEventListener('submit', function (e) {
    if (!composeAndValidate()) { e.preventDefault(); return; }
    saveState(); // answers already saved; capture the very latest before the page navigates
    if (bookBtn) { bookBtn.disabled = true; bookBtn.textContent = 'Sending\u2026'; }
    // A successful native submit navigates away and cancels this timer. If we're still here after 9s
    // (e.g. Shopify's spam check silently blocked the post), re-enable so nobody is ever stuck on "Sending".
    setTimeout(function () {
      if (bookBtn && bookBtn.disabled) {
        bookBtn.disabled = false; bookBtn.textContent = 'Try again \u2192';
        if (errEl) errEl.textContent = 'That took longer than expected; your answers are saved, so you can safely try again.';
      }
    }, 9000);
    // no preventDefault -> native Shopify submit; Shopify returns to ?contact_posted=true#intake-form (handled on load).
  });
  form.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList.contains('intake-input') && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
      if (idx !== total - 1) { if (nextBtn) nextBtn.click(); }
      else if (typeof form.requestSubmit === 'function') { form.requestSubmit(); }
      else if (bookBtn) { bookBtn.click(); }
    }
  });
  form.addEventListener('input', function (e) { if (e.target && e.target.classList) e.target.classList.remove('is-error'); saveState(); });
  render();
  // If Shopify returned from a native submit (JS-off fallback), land the user on the confirmation.
  if (location.search.indexOf('contact_posted=true') !== -1 && (location.hash === '#intake-form' || !document.getElementById('contact-form'))) {
    clearState();                 // submitted successfully -> discard the saved draft
    if (typeof openStart === 'function') openStart();
    showConfirm();
  } else {
    restoreState();               // returning mid-form or after a glitch -> bring answers back
  }
  applyInterestFromUrl();          // a fresh Packages-page click sets/updates the interest chip
})();

// FAQ accordion — one open at a time; opening a question closes the others. Opens to exact height so long answers never clip.
(function () {
  var rows = [].slice.call(document.querySelectorAll('.faq-row'));
  function close(row) {
    row.classList.remove('is-open');
    var q = row.querySelector('.faq-q'); if (q) q.setAttribute('aria-expanded', 'false');
    var a = row.querySelector('.faq-a'); if (a) a.style.maxHeight = '';
  }
  function open(row) {
    row.classList.add('is-open');
    var q = row.querySelector('.faq-q'); if (q) q.setAttribute('aria-expanded', 'true');
    var a = row.querySelector('.faq-a'); if (a) a.style.maxHeight = a.scrollHeight + 'px';
  }
  rows.forEach(function (row) {
    var q = row.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', function () {
      var wasOpen = row.classList.contains('is-open');
      rows.forEach(function (r) { if (r !== row) close(r); });
      if (wasOpen) close(row); else open(row);
    });
  });
  window.addEventListener('resize', function () {
    rows.forEach(function (row) {
      if (row.classList.contains('is-open')) {
        var a = row.querySelector('.faq-a'); if (a) a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  }, { passive: true });
})();

// general Contact form — honeypot spam guard + in-page submit (no email address exposed)
(function () {
  var form = document.getElementById('contact-form');
  if (!form) return;
  var btn  = form.querySelector('.contact-submit');
  var done = form.parentNode.querySelector('.contact-done');
  var hp   = form.querySelector('input[name="contact[website]"]'); // honeypot
  form.setAttribute('novalidate', 'novalidate');
  function showDone(){ var head = document.querySelector('.contact-head'); if (head) head.style.display = 'none'; if (done) { form.style.display = 'none'; done.hidden = false; done.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }

  form.addEventListener('submit', function (e) {
    // honeypot: real people never fill this hidden field; bots do. Fake success, don't send.
    if (hp && hp.value.trim() !== '') { e.preventDefault(); showDone(); return; }
    var need = form.querySelectorAll('[required]');
    for (var i = 0; i < need.length; i++) {
      if (!need[i].value.trim()) { e.preventDefault(); need[i].focus(); need[i].classList.add('is-empty'); return; }
    }
    if (btn) { btn.disabled = true; btn.textContent = 'Sending\u2026'; }
    setTimeout(function () { if (btn && btn.disabled) { btn.disabled = false; btn.textContent = 'Try again \u2192'; } }, 9000);
    // no preventDefault -> native Shopify submit; returns to ?contact_posted=true#contact-form (handled on load)
  });
  form.addEventListener('input', function (e) { if (e.target.classList) e.target.classList.remove('is-empty'); });
  // Shopify returns to /pages/contact?contact_posted=true#contact-form after a native submit.
  if (location.search.indexOf('contact_posted=true') !== -1) showDone();
})();

// initial nav theme — the portfolio view is the default landing view (dark hero at top)
(function(){ var pv = document.getElementById('view-portfolio'); if (pv && pv.style.display !== 'none') { document.documentElement.classList.add('on-portfolio'); } })(); // only when the portfolio view is the one showing (not the confirmation/start view)
updateNavTheme();

// intake confirmation → open the chosen Calendly event as an on-page popup overlay
(function () {
  var WCSS = 'https://assets.calendly.com/assets/external/widget.css';
  var WJS  = 'https://assets.calendly.com/assets/external/widget.js';
  function ready(){ return !!(window.Calendly && window.Calendly.initPopupWidget); }
  // Ensure the Calendly widget is loaded, THEN run cb(true). Loads it on demand if the async tag hasn't
  // finished (or isn't present, e.g. in a standalone preview). cb(false) only if it truly can't load.
  function ensureCalendly(cb) {
    if (ready()) { cb(true); return; }
    if (!document.querySelector('link[href*="calendly.com/assets/external/widget.css"]')) {
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = WCSS; document.head.appendChild(l);
    }
    var existing = document.querySelector('script[src*="calendly.com/assets/external/widget.js"]');
    if (existing) { // present but not ready yet — poll briefly
      var t = 0, iv = setInterval(function () {
        if (ready()) { clearInterval(iv); cb(true); }
        else if (++t > 50) { clearInterval(iv); cb(false); } // ~5s
      }, 100);
      return;
    }
    var s = document.createElement('script'); s.src = WJS; s.async = true;
    s.onload = function () { cb(ready()); };
    s.onerror = function () { cb(false); };
    document.head.appendChild(s);
  }
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.intake-book-card');
    if (!card) return;
    e.preventDefault();
    var url = card.getAttribute('data-cal');
    if (!url) return;
    window.open(url, '_blank', 'noopener'); // open Calendly in a new tab so every payment method (incl. Apple Pay) works
  });
})();

/* Deep-link router: /#start /#contact /#work /#about /#process — lets the nav/footer on
   standalone pages (e.g. Packages) land on the right spot when they return to the homepage. */
(function () {
  function route(){
    var h = location.hash; if (!h) return;
    if (h === '#start') { location.replace('/pages/start-your-project' + (location.search || '')); return; }
    if (h === '#contact') { location.replace('/pages/contact' + (location.search || '')); return; }
    // Old homepage anchors now have real pages; forward anyone arriving from an old link.
    var pages = { '#work': '/pages/work', '#about': '/pages/about', '#process': '/pages/process' };
    if (pages[h]) { location.replace(pages[h]); return; }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', route);
  else route();
})();


/* Adaptive nav: on pages whose sections carry data-nav-tone, colour the fixed header to match
   the section behind it — stable per section, never flipping on scroll direction. */
(function () {
  var nav = document.getElementById('main-nav');
  if (!nav || !document.querySelector('[data-nav-tone]')) return;
  var raf = null;
  function sample(){
    raf = null;
    var y = (nav.offsetHeight || 60) + 6;
    var el = document.elementFromPoint(Math.round(window.innerWidth / 2), y);
    var tone = 'dark';
    while (el && el !== document.documentElement){
      var t = el.getAttribute && el.getAttribute('data-nav-tone');
      if (t) { tone = t; break; }
      el = el.parentElement;
    }
    nav.classList.toggle('nav-on-light', tone === 'light');
    nav.classList.toggle('nav-on-dark', tone !== 'light');
  }
  function onScroll(){ if (!raf) raf = requestAnimationFrame(sample); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sample);
  else sample();
})();


/* ── v72: in-page anchor links ──────────────────────────────────────────
   Nav, footer and hero links are real <a href="#..."> now. Intercept the
   click for a calm eased scroll, keep the URL honest, and let #contact
   open the contact view via the existing router. Without JS these links
   still jump to the right section. */
(function () {
  var SPECIAL = {};   // #contact is a real page now
  var MAP = { '#work': '#work', '#about': '#about', '#process': '#process' };
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var hash = a.getAttribute('href');
    if (!hash || hash === '#') return;
    if (SPECIAL[hash]) {
      e.preventDefault();
      if (history.replaceState) history.replaceState(null, '', hash);
      SPECIAL[hash]();
      return;
    }
    var sel = MAP[hash] || hash;
    if (!document.querySelector(sel)) return;   // not ours; let the browser handle it
    e.preventDefault();
    var pv = document.getElementById('view-portfolio');
    if (pv && getComputedStyle(pv).display === 'none' && typeof showPortfolio === 'function') {
      showPortfolio();
      setTimeout(function () { calmScroll(sel); }, 80);
    } else {
      calmScroll(sel);
    }
    if (history.replaceState) history.replaceState(null, '', hash);
  });
})();


/* ── v72.3: masthead height, pinned filter bar, scroll-pause reveal ──────────
   1. Publish the real masthead height as --nav-h so the sticky filter bar can
      sit exactly under it at any type size or breakpoint.
   2. Flag the filter bar while it is actually pinned, so it can carry a surface
      only then (it stays transparent in the page flow).
   3. Bring the masthead back when scrolling stops. Auto-hide keeps the reading
      area clear; the pause reveal means "Get a Quote" is always one beat away. */
(function () {
  var nav = document.getElementById('main-nav');
  if (!nav) return;
  var root = document.documentElement;

  function measure() {
    root.style.setProperty('--nav-h', Math.round(nav.getBoundingClientRect().height) + 'px');
  }
  measure();
  window.addEventListener('resize', measure);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

  var bar = document.querySelector('.work .filter-bar');
  if (bar) {
    var pin = function () {
      var top = bar.getBoundingClientRect().top;
      var limit = root.classList.contains('nav-hidden') ? 1 : (parseInt(getComputedStyle(root).getPropertyValue('--nav-h'), 10) || 64) + 1;
      bar.classList.toggle('is-pinned', top <= limit);
    };
    window.addEventListener('scroll', pin, { passive: true });
    window.addEventListener('resize', pin);
    pin();
  }

  var idle = null;
  window.addEventListener('scroll', function () {
    if (idle) clearTimeout(idle);
    idle = setTimeout(function () {
      if (!root.classList.contains('nav-open')) root.classList.remove('nav-hidden');
    }, 420);
  }, { passive: true });
})();

/* Filter track on phones: show edge fades only when there is more to swipe to, and bring a
   tapped filter fully into view. Harmless on desktop, where the track does not scroll. */
(function(){
  var track=document.querySelector('.work .filter-track'); if(!track) return;
  function edges(){
    var max=track.scrollWidth-track.clientWidth;
    track.classList.toggle('can-scroll-left', track.scrollLeft>2);
    track.classList.toggle('can-scroll-right', max>2 && track.scrollLeft<max-2);
  }
  track.addEventListener('scroll', edges, {passive:true});
  window.addEventListener('resize', edges);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(edges);
  track.addEventListener('click', function(e){
    var b=e.target.closest('.filter-btn'); if(!b || track.scrollWidth<=track.clientWidth) return;
    b.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'});
  });
  edges();
})();


/* Nav hover menus: Work, Services and Packages each reveal a desktop panel under the nav.
   Opens on hover (with a short intent delay) or keyboard focus; closes on leave, Escape, or
   scroll-hide. Opening one closes the others, and the single scrim stays up across a switch so
   moving between them does not flash the page. Clicking the link still goes to its page. */
(function () {
  var scrim = document.querySelector('.wm-scrim');
  var mq = window.matchMedia('(min-width:1025px) and (hover:hover)');
  var menus = [];

  // One scrim for all three panels. Deferring the check by a frame means closing one panel and
  // opening another in the same tick settles to "still open" without a flicker between them.
  function syncScrim() {
    if (!scrim) return;
    requestAnimationFrame(function () {
      scrim.classList.toggle('is-open', !!document.querySelector('.wm.is-open'));
    });
  }

  function build(linkSel, panelId) {
    var link = document.querySelector(linkSel), panel = document.getElementById(panelId);
    if (!link || !panel) return;
    var openT = null, closeT = null;

    var m = {
      isOpen: function () { return panel.classList.contains('is-open'); },
      open: function () {
        if (!mq.matches) return;
        menus.forEach(function (o) { if (o !== m) o.close(true); });
        clearTimeout(closeT);
        panel.hidden = false;
        requestAnimationFrame(function () { panel.classList.add('is-open'); });
        link.setAttribute('aria-expanded', 'true');
        syncScrim();
      },
      close: function (now) {
        clearTimeout(openT);
        var done = function () {
          panel.classList.remove('is-open');
          link.setAttribute('aria-expanded', 'false');
          syncScrim();
        };
        if (now) { clearTimeout(closeT); done(); }
        else { clearTimeout(closeT); closeT = setTimeout(done, 180); }
      }
    };

    link.addEventListener('mouseenter', function () { clearTimeout(closeT); openT = setTimeout(m.open, 90); });
    link.addEventListener('mouseleave', function () { clearTimeout(openT); m.close(); });
    panel.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    panel.addEventListener('mouseleave', function () { m.close(); });

    // A click on the link is a navigation, not a menu toggle, so a mouse-driven focus must not
    // reopen the panel behind the page change.
    var byMouse = false;
    link.addEventListener('mousedown', function () { byMouse = true; setTimeout(function () { byMouse = false; }, 400); });
    link.addEventListener('focus', function () { if (!byMouse) m.open(); });

    document.addEventListener('focusin', function (e) {
      if (!m.isOpen()) return;
      if (e.target !== link && !panel.contains(e.target)) m.close(true);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && m.isOpen()) {
        var inside = panel.contains(document.activeElement);
        m.close(true);
        if (inside) link.focus();
      }
      if (e.key === 'ArrowDown' && document.activeElement === link && m.isOpen()) {
        var first = panel.querySelector('a');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });

    menus.push(m);
  }

  build('.nav-work', 'work-menu');
  build('.nav-services', 'services-menu');
  build('.nav-packages', 'packages-menu');
  if (!menus.length) return;

  function closeAll(now) { menus.forEach(function (m) { m.close(now); }); }
  if (scrim) scrim.addEventListener('click', function () { closeAll(true); });
  window.addEventListener('scroll', function () {
    if (document.documentElement.classList.contains('nav-hidden')) closeAll(true);
  }, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', function () { if (!mq.matches) closeAll(true); });
})();


/* Work page hover gallery. Each card's extra screenshots load only on first interaction.
   Desktop: after a short hover the card fades through its images, then returns to the cover on leave.
   Arrows flip manually (and pause auto-play until the mouse leaves). Touch: arrows only. */
(function () {
  var cards = document.querySelectorAll('.bw-media[data-gallery]');
  if (!cards.length) return;
  var canHover = window.matchMedia('(hover:hover)').matches;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  cards.forEach(function (media) {
    var slides = [].slice.call(media.querySelectorAll('.bw-slide'));
    var dots = [].slice.call(media.querySelectorAll('.bw-dots i'));
    var card = media.closest('.bw-card') || media;
    var i = 0, timer = null, start = null, manual = false;
    function load(s) { if (s && !s.getAttribute('src') && s.dataset.src) s.src = s.dataset.src; }
    function loadAll() { slides.forEach(load); }
    function ready(s) { return !s.dataset.src || (s.complete && s.naturalWidth > 0); }
    function show(n) {
      n = (n + slides.length) % slides.length;
      load(slides[n]); load(slides[(n + 1) % slides.length]);
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === n); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
      i = n;
    }
    function tick() { var n = (i + 1) % slides.length; if (ready(slides[n])) show(n); else load(slides[n]); }
    function stop() { clearTimeout(start); clearInterval(timer); start = timer = null; }
    media.querySelector('.bw-next').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); manual = true; stop(); loadAll(); show(i + 1); });
    media.querySelector('.bw-prev').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); manual = true; stop(); loadAll(); show(i - 1); });
    if (canHover) {
      card.addEventListener('mouseenter', function () {
        loadAll();
        if (calm || manual) return;
        start = setTimeout(function () { tick(); timer = setInterval(tick, 1300); }, 450);
      });
      card.addEventListener('mouseleave', function () { stop(); manual = false; show(0); });
    }
  });
})();


/* Featured-in carousel. The track slides so each publication lands in the centre of the stage,
   where it alone reads at full strength. The set is cloned either side so the travel never runs
   out of logos; when the track reaches the next copy it jumps back a set with the transition off,
   which is invisible because the arrangement is identical. Pauses on hover, off screen and on a
   hidden tab. Reduced motion keeps the original static row.
   Each item still carries its project credit as screen-reader text; there is no visible caption. */
(function () {
  var stage = document.querySelector('.featured-stage');
  var list = document.querySelector('.featured-list[data-spotlight]');
  if (!stage || !list) return;
  var originals = Array.prototype.slice.call(list.children);
  var N = originals.length;
  if (N < 2) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var HOLD = 2800, idx = N, timer = null, paused = false, items = originals;

  // Four copies in the track: one before the originals and two after, so both sides of the
  // centre always have logos to show while the middle set is the one being counted through.
  function copyOf(li) {
    var c = li.cloneNode(true);
    c.setAttribute('aria-hidden', 'true');              // the real list is already announced
    c.removeAttribute('id');
    return c;
  }
  function clone() {
    for (var pass = 0; pass < 2; pass++) {
      originals.forEach(function (li) { list.appendChild(copyOf(li)); });
    }
    // Build the leading copy in a fragment and insert it once. Inserting item by item before
    // firstChild would reverse the set and put a repeat directly beside its original.
    var lead = document.createDocumentFragment();
    originals.forEach(function (li) { lead.appendChild(copyOf(li)); });
    list.insertBefore(lead, list.firstChild);
    items = Array.prototype.slice.call(list.children);
  }

  // Centre the item at `i` in the stage, measuring live so logo widths can differ.
  function offsetFor(i) {
    var li = items[i];
    if (!li) return 0;
    return Math.round(stage.clientWidth / 2 - (li.offsetLeft + li.offsetWidth / 2));
  }

  function paint() {
    items.forEach(function (li, x) {
      li.classList.toggle('is-focus', x === idx);
      li.classList.toggle('is-near', x === idx - 1 || x === idx + 1);
      // A third ring, shown only on desktop, so the band spans the page instead of sitting as
      // three logos in the middle of it. CSS decides whether these are visible.
      li.classList.toggle('is-far', x === idx - 2 || x === idx + 2);
    });
  }

  function place(animate) {
    list.classList.toggle('is-sliding', !!animate);
    list.style.transform = 'translate3d(' + offsetFor(idx) + 'px,0,0)';
  }

  function step() {
    idx++;
    place(true);
    paint();
    // Reaching the third copy means the arrangement repeats, so rewind a set silently.
    if (idx >= N * 2) {
      setTimeout(function () {
        idx -= N;
        list.classList.remove('is-sliding');
        list.style.transform = 'translate3d(' + offsetFor(idx) + 'px,0,0)';
        paint();
      }, 800);
    }
  }

  function tick() { if (!paused) step(); timer = setTimeout(tick, HOLD); }
  function start() {
    if (timer) return;
    place(false); paint();
    timer = setTimeout(tick, HOLD);
  }
  function stop() { clearTimeout(timer); timer = null; }

  if (reduce.matches) {                                  // static row, no cloning, no motion
    stage.classList.add('is-live'); list.classList.add('is-live');
    return;
  }

  clone();
  stage.classList.add('is-live');
  list.classList.add('is-live');

  // Centring is measured from real logo widths, so nothing is positioned until the images have
  // decoded. A late loader also re-places, in case one arrives after the first paint.
  function whenReady(cb) {
    var imgs = list.querySelectorAll('img'), left = imgs.length;
    if (!left) return cb();
    var done = function () { if (--left <= 0) cb(); };
    Array.prototype.forEach.call(imgs, function (im) {
      if (im.complete && im.naturalWidth) done();
      else {
        im.addEventListener('load', done, { once: true });
        im.addEventListener('error', done, { once: true });
      }
    });
  }
  list.addEventListener('load', function () { place(false); }, true);
  whenReady(function () { place(false); paint(); });
  place(false);

  list.addEventListener('mouseenter', function () { paused = true; });
  list.addEventListener('mouseleave', function () { paused = false; });
  list.addEventListener('focusin', function () { paused = true; });
  list.addEventListener('focusout', function () { paused = false; });

  var rs = null;
  window.addEventListener('resize', function () {
    clearTimeout(rs);
    rs = setTimeout(function () { place(false); }, 150);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
    }, { threshold: 0.25 }).observe(stage);
  } else { start(); }
})();


/* Reviews page: progressive reveal. Every review is already in the markup, so with JavaScript off
   the grid simply shows all of them and there is no button. Here the script takes ownership by
   marking the grid live, which is what makes the hidden class bite, then reveals a batch per press
   and removes the button once nothing is left. Focus moves to the first newly shown review so a
   keyboard or screen-reader user lands on what just appeared rather than at the top of the page. */
(function () {
  var grid = document.querySelector('.rv-grid[data-reveal]');
  if (!grid) return;
  var btn = document.querySelector('[data-reveal-btn]');
  var hidden = function () { return grid.querySelectorAll('.rv-card.is-hidden'); };
  if (!btn || !hidden().length) return;

  var step = parseInt(grid.getAttribute('data-step'), 10);
  if (!(step > 0)) step = 6;

  grid.classList.add('is-reveal');
  btn.hidden = false;

  btn.addEventListener('click', function () {
    var rest = hidden();
    var n = Math.min(step, rest.length);
    var first = rest[0];
    for (var i = 0; i < n; i++) rest[i].classList.remove('is-hidden');
    if (!hidden().length) btn.hidden = true;
    if (first) {
      first.setAttribute('tabindex', '-1');
      first.focus({ preventScroll: true });
      first.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });
})();
